import { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { register } from '../../Services/authService'
import toast from 'react-hot-toast'
import Loader from '../Main/Loader'
import { useNavigate } from 'react-router-dom'
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa'

const RegisterCard = () => {


    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [contact, setContact] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleName = (e) => { setName(e.target.value) }
    const handleEmail = (e) => { setEmail(e.target.value) }
    const handlePassword = (e) => { setPassword(e.target.value) }
    const handleConfirmPassword = (e) => { setConfirmPassword(e.target.value) }
    const handleContact = (e) => { setContact(e.target.value) }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password != confirmPassword) {
            toast.error("password and confirm password does not match")
            setIsLoading(false)
            return;
        }

        let body = {
            name,
            email,
            password,
            password_confirmation: confirmPassword,
            contact
        }
        setIsLoading(true)
        let response = await register(body)
        if (response.code === 200) {
            toast?.success(response?.message)
            setIsLoading(false)
            setName("")
            setEmail("")
            setContact("")
            setPassword("")
            setConfirmPassword("")
            navigate("/")

        } else if (response.code != 200 || response.code != 201) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    return (
        <>

            <div className="card border-0 shadow p-3 mt-3">

                <h3 className='fw-bold'>Register</h3>

                <p>Create a new account to start earning</p>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                            onChange={handleName}
                            value={name}
                            type="text"
                            placeholder="Enter full name"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 phone-number" controlId="">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                            onChange={handleContact}
                            value={contact}
                            type="number"
                            placeholder="Enter phone number"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control
                            onChange={handleEmail}
                            value={email}
                            type="email"
                            placeholder="Enter email"
                        />
                    </Form.Group>

                    {/* Password Field with Eye Icon */}
                    <Form.Group className="mb-3 position-relative" controlId="formBasicPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            onChange={handlePassword}
                            value={password}
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                        />
                        <span
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                                position: 'absolute',
                                top: '38px',
                                right: '15px',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                        </span>
                    </Form.Group>

                    {/* Confirm Password Field with Eye Icon */}
                    <Form.Group className="mb-3 position-relative" controlId="formBasicConfirmPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                            onChange={handleConfirmPassword}
                            value={confirmPassword}
                            type={showConfirmPassword ? 'text' : 'password'}
                            placeholder="Password"
                        />
                        <span
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            style={{
                                position: 'absolute',
                                top: '38px',
                                right: '15px',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            {showConfirmPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                        </span>
                    </Form.Group>

                    <Button variant="primary" disabled={isLoading} className='w-100' type="submit">
                        {isLoading ? <Loader /> : "Register"}
                    </Button>
                </Form>
            </div>

        </>
    )
}

export default RegisterCard